'use strict';

const Resources = {};

Resources.HELP_CONTENT = {
    pce: {
        title: "PCE-Continuum College",
        contents: "Find courses that offer sections for PCE-Continuum College fee-based students. PCE students must register for PCE sections only. Non-PCE students must pay an extra fee to register for PCE sections. Call 206-543-2310 for registration and payment information."
    },
    /*
    instruction: {
        title: "Instruction Format Help",
        contents: "Select the 'in-person course' filter to find courses that include at least one section that is held in person and/or for which instruction locations are to be arranged (TBA). You may see a combination of in-person, TBA, and/or remote sections for each course."
    }
    */
    learningFormat: {
        title: "Learning Format Help",
        contents: ""
    }
};

export default Resources;